import React, {Fragment} from 'react';
import Box from '../layout/Box';
import createEditor from '../form/ComponentEditor';
import classNames from "classnames";
import ArticleForm from "./forms/articleForm";
import ArticleList from "./lists/articleList";
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import SelectorGrid from "../form/SelectorGrid/SelectorGrid";

class ArticleEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

	render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
		return (
			<Fragment>
                <List
                    {...this.props}
                    collapsed={this.props.collapsed || false}
                    theme="default"
                    header={"Cikk lista"}
					footer={[
                        <Button
                            key="0"
                            className="pull-left"
                            color="default"
                            onClick={this.pristineForm}
                        >
                            Új
                        </Button>
					]}
                >
                    <ArticleList ref={(el) => this.list = el} {...this.props} />
				</List>
				<Editor
                    {...this.props}
                    theme="default"
                    header={"Cikk adatai"}
					footer={[
						<Button
							key="0"
							disabled={!this.props.dirty}
							className="pull-right"
							color="primary"
							onClick={this.saveForm}
						>
							Mentés
						</Button>,
                        <Button
							key="1"
							disabled={!this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
							color="danger"
							className="pull-left"
							onClick={this.props.deleteForm}
						>
                            Törlés
                        </Button>
					]}
				>
                    <ArticleForm {...this.props} />
				</Editor>
				{
					this.props.values[this.props.componentConfig.idfield] && this.props.componentConfig.fielddefs.related_articles
					&&
					<Box
						theme="default"
						header="Kapcsolódó cikkek"
					>
						<SelectorGrid
							columns={{
								"headline": {header: 'Cím', width: 2, sortable: true, filterable: true}
							}}
							name={"related_articles"}
							listfieldlabel={"headline"}
							data={this.props.values}
							componentConfig={this.props.componentConfig}
							{...this.props.getFieldProps("related_articles")}
						/>
					</Box>
				}
			</Fragment>
		);
	}
}
export default createEditor({componentName: "article", WrappedComponent: ArticleEditor, props: {view: "admin"}});
